<div class="contenedor-buscador">
  <div class="head-text-info-search">
    <h1 class="text-info-search">Estas buscando: "{{ textoBusqueda }}"</h1>
  </div>
  <ng-container *ngIf="loading">
    <div class="spinner-container">
      <mat-spinner class="spinner"></mat-spinner>
      <div class="spinner-overlay">Esperando resultados...</div>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="noticias?.length > 0">
      <ng-container *ngFor="let item of noticias | slice: 0 : 45; trackBy: trackByNoticia; let i = index">
        <app-noticia-listado class="noticia-buscador" [noticia]="item" [idStart]="i" [txtBusqueda]="textoBusqueda"> </app-noticia-listado>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="noticias?.length == 0">
      <div class="imgNotFound"></div>
      <img src="/assets/images/not_found.webp" alt="no encontrado" width="100%" height="100%" />
      <h1 class="info-texto">No hemos encontrado lo que buscas, prueba con una nueva búsqueda</h1>
      <form class="form-buscador" #searchNotFound="ngForm" (ngSubmit)="enviarBusqueda(searchNotFound.value)">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Escriba para buscar..." name="buscar" ngModel />
        </mat-form-field>
        <button class="btn-buscar" mat-button (click)="enviarBusqueda(searchNotFound.value)">Buscar</button>
      </form>
    </ng-container>
  </ng-container>
</div>
